module.exports = __webpack_public_path__ + "static/media/AggregateLogo.1dd2657e.png";